export default "__VITE_ASSET__BkE$abQT__"